var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-header',{staticClass:"pb-6 pb-8 pt-5 pt-md-8",attrs:{"type":"gradient-info"}},[_c('button',{staticClass:"btn btn-primary text-uppercase mb-2"},[_vm._v("Add")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }